import GlobalLogin, { viewType } from './GlobalLogin';

export default GlobalLogin;
export { viewType };
